module.exports = __webpack_public_path__ + "7c524a4bdd93acf54ba7e2feb5b87ab3.MP3";